__webpack_require__.p = "https://static-assets.flydata.app/8d312b28a5044aa3d8c02187241f37276bb3ef2f/static/";